document.addEventListener('alpine:init', () => {
	Alpine.data('sc_textarea', (cfg = {}) => ({
		count: cfg.count || 0,
		autoGrow: cfg.autoGrow !== false,

		init() {
			if (this.autoGrow) {
				this.$nextTick(() => this.syncHeight());
			}
		},

		getTextarea() {
			return this.$refs.text || (this.$el.tagName === 'TEXTAREA' ? this.$el : this.$el.querySelector('textarea'));
		},

		syncHeight() {
			const el = this.getTextarea();
			if (!el) return;
			el.style.height = 'auto';
			el.style.height = `${el.scrollHeight}px`;
		},

		onInput(e) {
			const target = e?.target || this.getTextarea();
			if (target) {
				this.count = (target.value || '').length;
			}
			if (this.autoGrow) this.syncHeight();
		},

		reset() {
			const el = this.getTextarea();
			if (el) {
				el.value = '';
				this.count = 0;
			}
			if (this.autoGrow) {
				this.$nextTick(() => this.syncHeight());
			}
		}
	}));
});

